const initialState = {
  error: null,
  list: null,
};

const orderReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'ORDER_SUCCESS':
        return {
          ...state,
          error: null,
        };
      case 'ORDER_FAILURE':
        return {
          ...state,
          error: action.payload,
      };
      default:
        return state;
    }
  };
  
  export default orderReducer;
